<template>
  <div class="page page--whats-on">
    <smart-block
        link="/whats-on/local-events"
        background-color="#2D88BC"
        heading="Local Attractions"
    ></smart-block>
    <smart-block
        link="/whats-on/local-attractions"
        background-color="#83c815"
        heading="Local Events"
    ></smart-block>
    <smart-block
        link="https://www.manurewabusiness.co.nz/listing-category/eatery/"
        background-color="#f3bc19"
        heading="Eat and Drink Local"
    ></smart-block>
    <smart-block
        link="/whats-on/publications"
        background-color="#e77843"
        heading="Local Publications"
    ></smart-block>
    <smart-block
        link="/whats-on/auckland-live"
        icon="https://ucarecdn.com/25f9bbba-fd59-424d-8e40-bb77b4fa7cf1/aucklandevents.png"
        is-icon-only="is-icon-only"
        background-color="#fff"
        heading="Auckland Events"
        inverse="inverse"
    ></smart-block>
  </div>
</template>
<script>
import SmartBlock from "@/components/SmartBlock.vue";
export default {
  components: {
    SmartBlock
  }
}
</script>
